import { Component, input, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StatusBadgeColourScheme } from '../../../../controls/status-badge/status-badge-constants';
import { SIMPublicationStatus } from '../../../../../shared/constants/sim-publication-constants';

@Component({
    selector: 'app-sim-publication-status-badge',
    templateUrl: './sim-publication-status-badge.component.html',
    styleUrl: './sim-publication-status-badge.component.scss',
    standalone: false
})
export class SIMPublicationStatusBadgeComponent {
  @Input() simPublicationStatus: string = '';
  statusText: string = '';
  Current: string = SIMPublicationStatus.Current;
  Superseded: string = SIMPublicationStatus.Superseded;
  Withdrawn: string = SIMPublicationStatus.Withdrawn;
  AvailableSuperseded: string = SIMPublicationStatus.AvailableSuperseded;
  PendingRevision: string = SIMPublicationStatus.PendingRevision;
  Obsolescent: string = SIMPublicationStatus.Obsolescent;

  public statusBadgeColourSchemeEnum: StatusBadgeColourScheme = StatusBadgeColourScheme.Green;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['simPublicationStatus']) {
      this.statusBadgeColourSchemeEnum = this.getColourScheme(this.simPublicationStatus);
    }
  }

  getColourScheme(simPublicationStatus: string): StatusBadgeColourScheme {
    switch (simPublicationStatus) {
      case this.Current:
        return StatusBadgeColourScheme.Green;
      case this.Superseded:
        return StatusBadgeColourScheme.Red;
      case this.Withdrawn:
        return StatusBadgeColourScheme.warningOrange;
        case this.PendingRevision:
        return StatusBadgeColourScheme.Blue2;
      case this.Obsolescent:
      case this.AvailableSuperseded:
        return StatusBadgeColourScheme.grey;
      default:
        return StatusBadgeColourScheme.grey;
    }
  }
}

